const numbers = [61, 143, 206, 336, 389, 516, 574, 746, 877]

let linksVF = [null]
let saga = 1 
for (let i=1; i<=1088; i++) {
    if (numbers.includes(i)) {
        saga++
    }
    linksVF.push(`https://franime.fr/anime/one-piece?s=${saga}&ep=${i}&lang=vf`)
}

export default linksVF